import { has } from "../../../../utils/menu-context";
import i18n from "../../../../i18n";
import store from "../../../../store";

export const createConditionAction = () => {
    return {
        canCreate: ({ props, record }) => {
            let result = false
            const { menuContext } = props
            if (!has({ menuContext, key: 'canCreate' })) return false

            if (has({ menuContext: menuContext, key: 'forCompany' })) {
                result = record.isTmp != true || result
            }
            return result
        },
        canEdit: ({ props, record }) => {
            let result = false
            const { menuContext } = props
            if (!has({ menuContext, key: 'canEdit' }) || record.isActive === false) return false

            if (has({ menuContext: menuContext, key: 'forCompany' })) {
                result = ['Draft', 'Reject'].includes(record.refRequestStatus?.key) || result
                if (['Wait'].includes(record?.refRequestStatus?.key) && record?.refAssignedTo == null) {
                    result = true
                }
            }
            if (has({ menuContext: menuContext, key: 'forCertificateApprover' }) || has({ menuContext: menuContext, key: 'forCertificateSigner' })) {
                if (record.isTmp) {
                    return result = ['Wait', 'Approve'].includes(record.refRequestStatus?.key)  || result
                }
                result = ['Wait', 'Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(record.refRequestStatus?.key) || result
            }
            return result
        },
        canSendWait: ({ props, record }) => {
            let result = false
            const { menuContext } = props
            if (has({ menuContext, key: 'forCompany' })) {
                result = ['Draft', 'Reject'].includes(record.refRequestStatus?.key) || result
            }
            return result
        },
        canSign: ({ props, record }) => {
            let result = false
            const { menuContext } = props
            if (has({ menuContext: menuContext, key: 'forCertificateApprover' })) {
                result = ['Approve'].includes(record.refRequestStatus?.key) || result
            }
            if (has({ menuContext: menuContext, key: 'forCertificateSigner' })) {
                result = ['Approve'].includes(record.refRequestStatus?.key) || result
            }
            return result
        },
        canEditHologramNo: ({ props, record }) => {
            let result = false
            const { menuContext } = props
            if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext: menuContext, key: 'forCertificateSigner' })) {
                if (record.isTmp) {
                    return result = ['Wait', 'Approve', 'Wait Print'].includes(record.refRequestStatus?.key) || result
                }
                result = ['Wait', 'Approve', 'Wait Print', 'Printed'].includes(record.refRequestStatus?.key) || result
            }
            return result
        },
        canCancel: ({ props, record }) => {
            let result = false
            const { menuContext } = props
            if (has({ menuContext: menuContext, key: 'forCompany' }) ) {
                result = [undefined, 'Draft', 'Wait', 'Reject'].includes(record.refRequestStatus?.key) || result
            }
            return result
        }
    }
}

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ['refCompany'].includes(field?.key)
            },
            visibleField: ({ data }) => {
                const { companies } = data
                let visible = false
                if (companies?.length > 1) {
                    visible = true
                }
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly, isTmp } = props
                let enabled = false
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft'].includes(initialModel.refRequestStatus?.key) && !isTmp) {
                        enabled = (!viewOnly && !modelRef.isTmp ) || enabled
                    }
                }
                return { disabled: !enabled , 'onUpdate:value': value => {
                        modelRef.refCompany = value
                        modelRef.producerPlantName = store.state.resource.auth.info?.user?.firstNameTh
                        modelRef.producerAddress = modelRef.refCompany?.refFactoryAddrEn?.addrNo + " Moo. " + modelRef.refCompany?.refFactoryAddrEn?.addrMoo + ", " + modelRef.refCompany?.refFactoryAddrEn?.addrRoad + " Road, Tambon " + modelRef.refCompany?.factoryTambonEn + ", Amphur " + modelRef.refCompany?.refFactoryAddrEn?.refAmphur?.nameEn + ", " + modelRef.refCompany?.refFactoryAddrEn?.refProvince?.nameEn + ", " + modelRef.refCompany?.refFactoryAddrEn?.postCode
                        modelRef.refProducerProvince = modelRef.refCompany?.refFactoryAddrEn?.refProvince
                        modelRef.producerPostcode = modelRef.refCompany?.refFactoryAddrEn?.postCode
                        modelRef.producerPhoneNo = modelRef.refCompany?.refFactoryAddrEn?.phone
                    }
                }
            }
        },
        {
            check: ({ field }) => {
                return ['refDepartment'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly, isTmp} = props
                let enabled = false
                let list = undefined
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Reject', 'Wait'].includes(initialModel.refRequestStatus?.key) && !isTmp ) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                return { disabled: !enabled, list: list }
            }
        },
        {
            check: ({ field }) => {
                return ['refExportCountry'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly, isTmp } = props
                let enabled = false
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key) && !isTmp ) {
                        if(modelRef.refCompany) {
                            enabled = (!viewOnly && !modelRef.isTmp ) || enabled
                        }
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['refIntransitMethod'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef}) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        if ([undefined, 'N'].includes(modelRef.refIntransitMethod?.key)) {
                            modelRef.destinationViaPort = null;
                            modelRef.refDestinationViaCountry = null;
                        }
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        if ([undefined, 'N'].includes(modelRef.refIntransitMethod?.key)) {
                            modelRef.destinationViaPort = null;
                            modelRef.refDestinationViaCountry = null;
                        }
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['refDestinationViaCountry', 'destinationViaPort'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['I', 'V'].includes(modelRef.refIntransitMethod?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel , modelRef}) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if(['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        if(['I', 'V'].includes(modelRef.refIntransitMethod?.key)) {
                            enabled = (!viewOnly && !modelRef.isTmp) || enabled
                        }
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        if(['I', 'V'].includes(modelRef.refIntransitMethod?.key)) {
                            enabled = !viewOnly || enabled
                        }
                    }
                }
                return { disabled: !enabled }
            }
        },
        /*{
            check: ({ field }) => {
                return ['refTransportTemperature'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef}) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if ([undefined,'A'].includes(modelRef.refTransportTemperature?.key)) {
                    modelRef.temperatureValue = null;
                }

                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },*/
       /* {
            check: ({ field }) => {
                return ['temperatureValue'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef}) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if(['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        if(['C', 'F'].includes(modelRef.refTransportTemperature?.key)) {
                            enabled = (!viewOnly && !modelRef.isTmp) || enabled
                        }
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        if(['C', 'F'].includes(modelRef.refTransportTemperature?.key)) {
                            enabled = !viewOnly || enabled
                        }
                    }
                }
                return { disabled: !enabled }
            }
        },*/
        {
            check: ({ field }) => {
                return ['packagingSize'].includes(field?.key)
            },
            visibleField: ({ initialModel }) => {
                let visible = false
                return !initialModel.isAllModels || visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['qty'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                        if(modelRef.isAllModels) {
                            enabled = false
                        }
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                        if(modelRef.isAllModels) {
                            enabled = false
                        }
                    }
                }
                return { disabled: !enabled}
            }
        },
        // normal
        {
            check: ({ field }) => {
                return [
                    'refRequestForm','refIntransitForm',
                    'producerPlantName','producerAddress','refProducerProvince','producerPostcode','producerPhoneNo',
                    'refReportProducerAddressCase', 'refReportExporterAddressCase',
                    'exporterName','exporterAddress','refExporterProvince','exporterPostcode','exporterPhoneNo',
                    'consigneeName','consigneeAddress','consigneeCity','consigneePostcode','consigneePhoneNo',
                    'commodityName','netWeight','grossWeight','productCodeNo', 'refExportAmountUnit',
                    'refTransportMode','vehicleName','referenceDocNo','sourcePortCity','destinationPort',
                    'loadingDate','shipmentDate','containerNo','sealNo', 'refTransportTemperature', 'temperatureValue','shippingMask'/*,'fob'*/
                ].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['additionalVouchTextRemark', 'replacementRemark', 'remark'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        //additionRemark
        {
            check: ({ field }) => {
                return ['typeOfTreatment', 'typeOfTreatmentHiddenBlock'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = [
                    'UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                    , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                    , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                    , 'EST', 'ROU', 'HRV', 'bosnia_and_herzegovina', 'serbia', 'turkey', 'china_export', 'CHN-Export', 'israel', 'north_macedonia', 'malaysia', 'montenegro', 'morocco', 'new_caledonia',
                    'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'
                ].includes(modelRef.refRequestForm?.key) ||
                    [
                        'UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV', 'bosnia_and_herzegovina', 'serbia', 'turkey', 'china_export', 'CHN-Export', 'israel', 'north_macedonia', 'malaysia', 'montenegro', 'morocco', 'new_caledonia',
                        'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'
                    ].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['hsCode', 'hsCodeHiddenBlock'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = [
                    'UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                    , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                    , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                    , 'EST', 'ROU', 'HRV', 'bosnia_and_herzegovina', 'serbia', 'turkey', 'brazil_fishery', 'Composite Food', 'korea_fishhead', 'north_macedonia', 'malaysia', 'montenegro', 'new_zealand_bivalue', 'saudi_arabia',
                    'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'
                ].includes(modelRef.refRequestForm?.key) ||
                    [
                        'UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV', 'bosnia_and_herzegovina', 'serbia', 'turkey', 'brazil_fishery', 'Composite Food', 'korea_fishhead', 'north_macedonia', 'malaysia', 'montenegro', 'new_zealand_bivalue', 'saudi_arabia',
                        'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'
                    ].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['regionOfOrigin', 'approvalZone', 'regionOfDestination', 'approvalZone2'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                            , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                            , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                            , 'EST', 'ROU', 'HRV', 'Composite Food', 'new_zealand_bivalue', 'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT']
                        .includes(modelRef.refRequestForm?.key) ||
                            ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                                , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                                , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                                , 'EST', 'ROU', 'HRV', 'Composite Food', 'new_zealand_bivalue', 'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return [
                    'nameOfOperator', 'addressOfOperator', 'cityOfOperator', 'postcodeOfOperator', 'phoneNoOfOperator', 'phoneNoOfOperatorHiddenBlock', 'refOperatorCountry', 'isoOperatorCountry',
                    'namePlaceOfDestination', 'addressPlaceOfDestination', 'refPlaceOfDestinationCountry', 'isoPlaceOfDestinationCountry',
                    'accompanyingDocumentType', 'accompanyingDocumentNo', 'refAccompanyingDocumentCountry', 'isoAccompanyingDocumentCountry',
                    'isCanningIndustry', 'isHumanConsumption', 'goodCertifiedAsHiddenBlock', 'batchNo', 'batchNoHiddenBlock', 'isFinalConsumer', 'isFinalConsumerHiddenBlock',
                    'imsocReference', 'isLiveAquaticAnimalForHumanConsumption', 'isFurtherProcessing', 'isForInternalMarket', 'coldStore',
                    'regNoPlaceOfDestination'
                ].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                            , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                            , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                            , 'EST', 'ROU', 'HRV'].includes(modelRef.refRequestForm?.key) ||
                    ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['manufacturingDate', 'manufacturingDateHiddenBlock'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = [
                    'argentina', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                    , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                    , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                    , 'EST', 'ROU', 'HRV', 'azerbaijan', 'russia', 'china_export', 'CHN-Export', 'french_polynesia', 'israel', 'korea_fishhead', 'morocco', 'saudi_arabia',
                    'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'
                ].includes(modelRef.refRequestForm?.key) ||
                    ['argentina', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV', 'azerbaijan', 'russia', 'china_export', 'CHN-Export', 'french_polynesia', 'israel', 'korea_fishhead', 'morocco', 'saudi_arabia',
                        'COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'
                    ].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['expiredDate', 'expiredDateHiddenBlock'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['argentina', 'french_polynesia', 'israel', 'morocco', 'saudi_arabia'].includes(modelRef.refRequestForm?.key) || ['argentina', 'french_polynesia', 'israel', 'morocco', 'saudi_arabia'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef}) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['healthCertificateNo', 'healthCertificateDate', 'refFromCountryOfOrigin', 'refFromCountryOfOriginHiddenBlock'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['australia_salmonid', 'new_zealand_salmon'].includes(modelRef.refRequestForm?.key) || ['australia_salmonid', 'new_zealand_salmon'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return [
                    'refCountryOfOriginOfRawMaterial','countryOfOriginOfRawMaterial', 'refProcessingType', 'refCharacterOfProductiveWaterArea',
                    'fishVesselFactoryDetail', 'transportVesselDetail', 'coldStorageMaterialDetail', 'coldStorageProductDetail',
                    'lotNoOfProduct', 'flightNo', 'otherTransportMean'
                ].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['china_export', 'CHN-Export'].includes(modelRef.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['isAquaculture', 'isWildCaught', 'refIsAquaculture', 'refIsWildCaught'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['china_export', 'CHN-Export'].includes(modelRef.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        /*{
            check: ({ field }) => {
                return ['refIsAquaculture', 'refIsWildCaught'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                if(['china_export', 'CHN-Export'].includes(modelRef.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(modelRef.refIntransitForm?.key) ) {
                    visible = true
                }
                return visible
            },
        },*/
        {
            check: ({ field }) => {
                return ['aquacultureArea', 'aquacultureAreaHiddenBlock', 'aquacultureFarmNameAndRegistrationNo'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                if(['china_export', 'CHN-Export'].includes(modelRef.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(modelRef.refIntransitForm?.key) ) {
                    visible = true
                }
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && modelRef.refIsAquaculture) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && modelRef.refIsAquaculture) || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['catchArea', 'catchVesselNameAndNo', 'fishVesselDetail'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                if(['china_export', 'CHN-Export'].includes(modelRef.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(modelRef.refIntransitForm?.key) ) {
                    visible = true
                }
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && modelRef.refIsWildCaught) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && modelRef.refIsWildCaught) || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },

        {
            check: ({ field }) => {
                return [
                    'slaughterhouse', 'dairyProducingCountries', 'euApprovalNo', 'isProduceDairyPeriod', 'dairyProduceStartDateStr', 'eggOriginCountries'
                ].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                if(['COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'].includes(modelRef.refRequestForm?.key)
                    || ['COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'].includes(modelRef.refIntransitForm?.key) ) {
                    visible = true
                }
                return visible
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['dairyProduceEndDateStr'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                if(['COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'].includes(modelRef.refRequestForm?.key)
                    || ['COMP-EU-DE', 'COMP-EU-EN', 'COMP-EU-FR', 'COMP-EU-IT', 'COMP-EU-NL', 'COMP-EU-PT'].includes(modelRef.refIntransitForm?.key) ) {
                    visible = true
                }
                return visible
            },
            inputPropField: ({ modelRef }) => {
                return { disabled: !modelRef.isProduceDairyPeriod}
            }
        },

        {
            check: ({ field }) => {
                return [
                    'isProcessedDairyProduct', 'isProcessedDairyProductHiddenBlock',
                    'refProducedInTheCountry', 'approvalNo',
                    'refProductOn', 'refProductOnHiddenBlock', 'productOnDate', 'productOnDateHiddenBlock', 'productOnBetweenDate1', 'productOnBetweenDate2',
                    'refApprovalCountry', 'refApprovalCountryHiddenBlock'
                ].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['Composite Food'].includes(modelRef.refRequestForm?.key) || ['Composite Food'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['freezingDate', 'freezingDateHiddenBlock'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['french_polynesia'].includes(modelRef.refRequestForm?.key) || ['french_polynesia'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['refHumanConsumption', 'refHumanConsumptionHiddenBlock'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['israel'].includes(modelRef.refRequestForm?.key) || ['israel'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['farmLocations'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                visible = ['new_zealand_tilapia_or_catfish'].includes(modelRef.refRequestForm?.key) || ['new_zealand_tilapia_or_catfish'].includes(modelRef.refIntransitForm?.key) || visible
                return visible
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.isTmp) || enabled
                    }
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },

        // always disable input field
        {
            check: ({ field }) => {
                return ['requestNo', 'requestDate', 'requester', 'refCompany.nameEn', 'refCompany.thNo', 'refCompany.branch', 'refSourcePortCountry', 'refDestinationPortCountry'].includes(field?.key)
            },
            inputPropField: () => {
                return { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return ['requestChangeInformationNo'].includes(field?.key)
            },
            visibleField: ({ modelRef }) => {
                let visible = false
                const { isTmp } = modelRef
                if(isTmp) {
                    visible = true
                }
                return visible
            },
            inputPropField: () => {
                return { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return ['correctionDetail'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCompany' })) {
                    if ([undefined, 'Draft', 'Wait', 'Reject'].includes(initialModel.refRequestStatus?.key)) {
                        enabled = !viewOnly || (["Cancel"].includes(modelRef.refRequestChangeInformationTopic?.key)) || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['approverRemark', 'refRequestStatus'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    if (['Pending Review'].includes(initialModel.refRequestStatus?.key) || (initialModel?.isTmp && ['Wait'].includes(initialModel?.refRequestStatus?.key)) ) {
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return ['certificateApprovalDate'].includes(field?.key)
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { menuContext, viewOnly } = props
                let enabled = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner' })) {
                    // if (['Pending Review'].includes(initialModel?.refRequestStatus?.key) || (initialModel?.isTmp && ['Wait'].includes(initialModel?.refRequestStatus?.key))) {
                    //     enabled = (!viewOnly && ['Approve'].includes(modelRef.refRequestStatus?.key) && (!modelRef.isTmp)) || enabled
                    // }
                    if (['Approve'].includes(initialModel?.refRequestStatus?.key)) {
                        enabled = (!viewOnly) && (!modelRef.isTmp) || enabled
                    }
                }
                return { disabled: !enabled }
            }
        },

        // ----------------------------- section check -----------------------------------
        {
            check: ({ sectionKey }) => {
                return ['CertificateProduct'].includes(sectionKey)
            },
            cardProp: ({ props }) => {
                let title = undefined
                if (props.isAllModels) {
                    title = i18n.global.t('views.certificate.certificateRequest.certificateProduct.allModels.title')
                } else {
                    title = i18n.global.t('views.certificate.certificateRequest.certificateProduct.continuous.title')
                }
                return { title }
            },
            componentProp: ({ props, modelRef }) => {
                const {  viewOnly } = props
                let visibleSamplingNo = false
                let visibleProductCode = false
                let visibleProductNameEn = false
                let visibleSamplingProductNameTh = false
                let visiblePackageSize= false //ขนาดบรรจุ
                let visibleExportAmount = false
                let visibleBalanceAmount = false //Auto calculate(SamplingRequest.exportAmount - CertificateProduct.exportAmount)
                let visibleExportCountry = false
                let visibleSamplingProducts = false
                let visibleCompanyProducts = false

                if(modelRef.isAllModels) {
                    visibleSamplingNo = true
                    visibleProductNameEn = true
                    visibleSamplingProductNameTh =  true
                    visiblePackageSize= true
                    visibleExportAmount = true
                    visibleBalanceAmount = true
                    visibleExportCountry = true
                    visibleSamplingProducts = true
                    visibleCompanyProducts = false
                } else {
                    visibleProductCode = true
                    visibleProductNameEn = true
                    visibleSamplingProductNameTh =  true
                    visibleCompanyProducts =true
                }
                return {
                    viewOnly: viewOnly,
                    itemsKey: "certificateProducts",
                    visibleSamplingProducts,
                    visibleCompanyProducts,
                    visibleSamplingNo,
                    visibleProductCode,
                    visibleProductNameEn,
                    visibleSamplingProductNameTh,
                    visiblePackageSize,
                    visibleExportAmount,
                    visibleBalanceAmount,
                    visibleExportCountry,
                    visibleSearch: false
                }
            }
        },
        //---------------------------------------------------------------------------
        {
            check: ({ sectionKey }) => {
                return ['packagingSizeAllModels'].includes(sectionKey)
            },
            visibleSection: ({ props, initialModel }) => {
                const { isAllModels } = props
                let visible = false
                if(initialModel.isAllModels || isAllModels) {
                    visible = true
                }
                return visible
            },
            componentProp: ({ props, modelRef }) => {
                const { viewOnly, canAddProduct } = props
                let visibleSamplingNo = false
                let visiblePackageSize= false //ขนาดบรรจุ
                let visibleExportAmount = false
                let visibleSamplingProducts = false
                let isTablePackaging = false
                if(modelRef.isAllModels) {
                    visibleSamplingProducts = true
                    visibleSamplingNo = true
                    visiblePackageSize= true
                    visibleExportAmount = true
                    isTablePackaging = true
                }
                return {
                    canAddProduct: canAddProduct,
                    viewOnly: viewOnly,
                    itemsKey: "certificateProducts",
                    visibleSamplingProducts,
                    isTablePackaging,
                    visibleSamplingNo,
                    visiblePackageSize,
                    visibleExportAmount,
                    visibleSearch: false
                }
            }
        },
        {
            check: ({ sectionKey }) => {
                return ['ProductDetail'].includes(sectionKey)
            },
            componentProp: () => {
                return {
                    viewOnly: true,
                    itemsKey: "aquaticScientificNames",
                    visibleCompany: false
                }
            }
        },
        {
            check: ({ sectionKey }) => {
                return ['CorrectionDetail'].includes(sectionKey)
            },
            visibleSection: ({ props, initialModel }) => {
                const { isTmp } = props
                let visible = (isTmp || initialModel.isTmp ) || false
                return visible
            },
        },
        {
            check: ({ sectionKey }) => {
                return ['OfficerPart'].includes(sectionKey)
            },
            visibleSection: ({ props, initialModel }) => {
                const { menuContext } = props
                let visible = false
                if (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext, key: 'forCertificateSigner'})) {
                    visible = true
                }
                if (has({ menuContext, key: 'forCompany' })) {
                    visible = ['Reject'].includes(initialModel.refRequestStatus?.key) || visible
                }
                return visible
            },
        },
    ]
}

